// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.doc-content {
    font-family: Arial, sans-serif;
    max-width: 800px;
    margin: 20px auto;
    padding: 20px;
    background: #fff;
    color: #333;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0,0,0,0.1);
}

.title {
    font-size: 24px;
    color: #000;
    font-weight: bold;
    margin-bottom: 20px;
}

p {
    font-size: 16px;
    line-height: 1.6;
    margin-bottom: 15px;
}

h2, h3 {
    font-size: 20px;
    color: #333;
    font-weight: bold;
    margin-top: 20px;
    margin-bottom: 10px;
}

ul {
    margin-left: 20px;
    list-style-type: disc; /* or another style if preferred */
}

li {
    margin-bottom: 10px;
    font-size: 16px;
    line-height: 1.6;
}
`, "",{"version":3,"sources":["webpack://./src/views/Pages/PrivacyPolicy.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB,EAAE,kCAAkC;AAC7D;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB","sourcesContent":[".doc-content {\n    font-family: Arial, sans-serif;\n    max-width: 800px;\n    margin: 20px auto;\n    padding: 20px;\n    background: #fff;\n    color: #333;\n    border-radius: 8px;\n    box-shadow: 0 0 10px rgba(0,0,0,0.1);\n}\n\n.title {\n    font-size: 24px;\n    color: #000;\n    font-weight: bold;\n    margin-bottom: 20px;\n}\n\np {\n    font-size: 16px;\n    line-height: 1.6;\n    margin-bottom: 15px;\n}\n\nh2, h3 {\n    font-size: 20px;\n    color: #333;\n    font-weight: bold;\n    margin-top: 20px;\n    margin-bottom: 10px;\n}\n\nul {\n    margin-left: 20px;\n    list-style-type: disc; /* or another style if preferred */\n}\n\nli {\n    margin-bottom: 10px;\n    font-size: 16px;\n    line-height: 1.6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
